<template>
  <div class="c-latest-insight" :class="{ full: fullWidth }">
    <sc-text
      tag="div"
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-latest-insight__label"
    />
    <sc-text
      tag="div"
      v-if="fields && fields.title"
      :field="fields.title"
      class="c-latest-insight__title"
    />
    <div class="c-latest-insight__description">
      <sc-text v-if="fields && fields.description" :field="fields.description" />
    </div>
    <sc-link
      v-if="
        fields &&
        fields.link &&
        fields.link.value &&
        fields.link.value.href &&
        fields.link.value.href != ''
      "
      :field="fields.link"
      class="c-cta--secondary"
      :class="fields.link.value.class"
    />
    <div
      v-if="
        fields &&
        fields.linkSecond &&
        fields.linkSecond.value &&
        fields.linkSecond.value.href &&
        fields.linkSecond.value.href != ''
      "
    >
      <sc-link
        v-if="fields && fields.linkSecond"
        :field="fields.linkSecond"
        class="c-cta--tertiary"
        :class="fields.linkSecond.value.class"
      />
    </div>
  </div>
</template>

<script>
import { Text, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Latest-Insights-Item-Static',
  components: {
    ScText: Text,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    fullWidth() {
      return this.fields?.fullWidth?.value;
    }
  }
};
</script>
